<template>
    <div class="floor job">
		<!-- 楼层标题 -->
		<div class="floor_title">
		    <div class="floor_title_content">
		        <span class="floor_title_border"></span>
		        <span class="floor_title_content_index">{{ floorConfig.index || "求职招聘" }}</span>
		        <span class="floor_title_content_text">{{ floorConfig.title || "" }}</span>
		    </div>
		    <div class="other-title" >
		        <router-link to="/job">查看更多<i class="iconfont iconarrow-right"></i></router-link>
		    </div>
		</div>
        <!-- 楼层内容区 -->
		<div class="floor-content">
			<div class="job-list" v-if="jobList.length">
				<div class="item" v-for="(item,i) in  jobList" :key="item.id"  @click="$router.pushToTab({ path: '/job-detail-' + item.id })">
					<div class="info">
						<h2>{{item.title}}</h2>
						<div >
							<!-- {{typeof item.salary}} -->
							<span>{{item.create_time.split(' ')[0]}}</span>
							<span class="salary" v-if="item.salary >0 && typeof item.salary == 'number'">{{Math.round(item.salary/1000)}}K</span>
							<span class="salary" v-else>面议</span>
							<span>{{item.area.name}}</span>
							<span>{{workingList[item.working]}}</span>
							<span>{{educationList[item.education]}}</span>
						</div>
					</div>
					<!-- <div class="con">
						<h3>{{item.site.site_name}}</h3>
					</div> -->
				</div>
			</div>
			
		</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { jobList } from "@/api/cms/job"
	
    export default {
        name: "job",
        components: {
        },
        props: {
            config: {
                type: Object,
                // required: true
            }
        },
        data() {
            return {
                floorConfig: {
                    validated: false,
                    rightCargos: []
                },
                jobList: [],
				priceList:[
					{
						min_price:'',
						max_price:'',
						name:'不限'
					},
					{
						min_price:0,
						max_price:5000,
						name:'5千'
					},
					{
						min_price:5000,
						max_price:10000,
						name:'5千-1万'
					},
					{
						min_price:10000,
						max_price:20000,
						name:'1万-2万'
					},
					{
						min_price:20000,
						max_price:50000,
						name:'2万-5万'
					},
					{
						min_price:50000,
						max_price:99999999,
						name:'5万以上'
					},
				],
				workingList:[
					//0不限制 1在校生应届生 2 1-3年 3,3-5年,4,5-10年,5,10年以上
					'不限制',
					'在校生应届生',
					'1-3年',
					'3-5年',
					'5-10年',
					'10年以上',
				],
				educationList:[
					//0学历要求 默认0 |0不限制|1初中|2高中\中职\中专|3大专|4本科|5硕士|6博士
					'不限制',
					'初中',
					'高中\中职\中专',
					'大专',
					'本科',
					'硕士',
					'博士',
				],
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
            this.getjobList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            tojob(item) {
                if (item) {
                    this.$router.pushToTab(`/list?job_id=${item.job_id}`)
                }
            },
            getjobList() {
                // const sku_ids = this.floorConfig.rightCargos
                //     .map(item => {
                //         return item.sku_id
                //     })
                //     .toString()
				
                jobList({
					page_size:8
				})
                    .then(res => {
                        this.jobList = res.data.list
                    })
                    .catch(err => {})
            }
        },
        watch: {
            config: {
                handler: function(curr) {
                    if (curr && curr.rightCargos) {
                        this.floorConfig = { ...curr, validated: true }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .floor {
		width: 1210px;
		&_title {
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    padding-right: 20px;
		    &_border {
		        display: inline-block;
		        width: 5px;
		        height: 28px;
		        background-color: $base-color;
		        margin-right: 12px;
		        vertical-align: top;
		    }
		
		    &_content {
		        font-size: 20px;
		        padding-top: 10px;
		        padding-bottom: 10px;
		        height: 48px;
		        line-height: 28px;
		        // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
		        box-sizing: border-box;
		
		        &_index {
		            display: inline-block;
		            color: $ns-text-color-black;
		            padding-right: 8px;
		            font-weight: 600;
		        }
		
		        &_text {
		            font-weight: 600;
		            display: inline-block;
		            color: $base-color;
		        }
		    }
			.other-title {
			    a {
			        color: #838383;
			
			        i {
			            font-size: 14px;
			        }
			
			        &:hover {
			            color: $base-color;
			        }
			    }
			}
		}
        .floor-content {
            display: flex;
            flex-wrap: wrap;
			.job-list {
				// float: left;
				flex: 1;
				margin-top: 10px;
				margin-right: 15px;
				background-color: #fff;
				.item{
					// display: flex;
					// flex-wrap: wrap;
					padding: 5px 15px;
					// margin-bottom: 15px;
					border: 1px solid #eee;
					.info{
						// flex:1;
						display: flex;
						width: 100%;
						h2{
							width: 40%;
							color: $base-color;
							font-size: 16px;
							line-height: 30px;
						}
						div {
							width: 60%;
							// flex:1;
							margin: 5px 0 0 0;
							display: flex;
							height: 25px;
							flex-direction:row-reverse;
							.salary{
								color: $base-color;
								font-size: 16px;
								line-height: 20px;
								// width: 60px;
							}
							span{
								// margin:0  10px;
								line-height: 16px;
								height: 16px;
								// padding-right: 10px;
								display: flex;
								float: left;
								width: auto;
								text-align: center;
								border-left: 1px solid #000;
								margin:0 10px 0 0;
								padding:0 10px;
							}
							// span::after{
							// 	content:'|';
							// 	font-size: 13px;
							// 	display: block;
							// 	width: 1px;
							// 	// height: 16px;
							// 	// width: 1px;
							// 	margin: 0 10px;
							// 	color: #303133;
							// 	// height: 24px;
							// 	// line-height: 28px;
							// 	overflow: hidden;
							// 	border-right: 1px solid #000;
							// }
							span:last-child{
								// display: none;
								border:0
							}
						}
					}
					.con{
						width: 300px;
						display: block;
						h3{
							font-size: 15px;
							line-height: 60px;
						}
					}
				}
			}
			.empty {
				margin-top: 45px;
			}
        }
    }
</style>
